import { render, staticRenderFns } from "./VFormError.vue?vue&type=template&id=07a71e53&"
import script from "./VFormError.vue?vue&type=script&lang=js&"
export * from "./VFormError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports